export default {
      id: "globe-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#globe",
      toString: function () {
        return this.url;
      }
    }